import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../../redux/modules/store';
import CustomCount from '../../../component/molecules/CustomCount';


const mapStateToProps = (appState: AppState) => {
  return {
    filterList: appState.filterList,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomCount);
